import React, { FC, ReactNode } from 'react';

import { HelpModeProvider } from './HelpModeContext';
import HelpModeController from './HelpModeController';

interface HelpModeWrapperProps {
  children: ReactNode;
}

const HelpModeWrapper: FC<HelpModeWrapperProps> = ({ children }) => {
  return (
    <HelpModeProvider>
      <HelpModeController />
      {children}
    </HelpModeProvider>
  );
};

export default HelpModeWrapper;
